import { makeWebchatWidgetProvider } from 'modules/webchat/infra/providers';
import {
  makeWebchatChatSessionsRepository,
  makeWebchatTokensRepository,
} from 'modules/webchat/infra/repositories';

import MountWebchatUseCase from './implementations/MountWebchatUseCase';

let instance: MountWebchatUseCase | null = null;

export default function makeMountWebchatUseCase() {
  if (!instance) {
    instance = new MountWebchatUseCase(
      makeWebchatWidgetProvider(),
      makeWebchatChatSessionsRepository(),
      makeWebchatTokensRepository(),
    );
  }

  return instance;
}
